export const AG_GRID_LOCALE_EN =  {
    // Set Filter
    selectAll: '(Select All)',
    selectAllSearchResults: '(Select All Search Results)',
    searchOoo: 'Search...',
    blanks: '(Blanks)',
    noMatches: 'No matches',

    // Number Filter & Text Filter
    filterOoo: 'Filter...',
    equals: 'Equals',
    notEqual: 'Not equal',
    empty: 'Choose One',

    // Number Filter
    lessThan: 'Less than',
    greaterThan: 'Greater than',
    lessThanOrEqual: 'Less than or equal',
    greaterThanOrEqual: 'Greater than or equal',
    inRange: 'In range',
    inRangeStart: 'to',
    inRangeEnd: 'from',

    // Text Filter
    contains: 'Contains',
    notContains: 'Not contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: 'AND',
    orCondition: 'OR',

    // Filter Buttons
    applyFilter: 'Apply',
    resetFilter: 'Reset',
    clearFilter: 'Clear',
    cancelFilter: 'Cancel',

    // Filter Titles
    textFilter: 'Text Filter',
    numberFilter: 'Number Filter',
    dateFilter: 'Date Filter',
    setFilter: 'Set Filter',

    // Side Bar
    columns: 'Columns',
    filters: 'Filters',

    // columns tool panel
    pivotMode: 'Pivot Mode',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
    values: 'Values',
    valueColumnsEmptyMessage: 'Drag here to aggregate',
    pivots: 'Column Labels',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',

    // Header of the Default Group Column
    group: 'Group',

    // Other
    loadingOoo: 'Loading...',
    noRowsToShow: 'No Rows To Show',
    enabled: 'Enabled',

    // Menu
    pinColumn: 'Pin Column',
    pinLeft: 'Pin Left',
    pinRight: 'Pin Right',
    noPin: 'No Pin',
    valueAggregation: 'Value Aggregation',
    autosizeThiscolumn: 'Autosize This Column',
    autosizeAllColumns: 'Autosize All Columns',
    groupBy: 'Group by',
    ungroupBy: 'Un-Group by',
    resetColumns: 'Reset Columns',
    expandAll: 'Expand All',
    collapseAll: 'Close All',
    copy: 'Copy',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copy With Headers',
    paste: 'Paste',
    ctrlV: 'Ctrl+V',
    export: 'Export',
    csvExport: 'CSV Export',
    excelExport: 'Excel Export (.xlsx)',
    excelXmlExport: 'Excel Export (.xml)',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Sum',
    min: 'Min',
    max: 'Max',
    none: 'None',
    count: 'Count',
    avg: 'Average',
    filteredRows: 'Filtered',
    selectedRows: 'Selected',
    totalRows: 'Total Rows',
    totalAndFilteredRows: 'Rows',
    more: 'More',
    to: 'to',
    of: 'of',
    page: 'Page',
    nextPage: 'Next Page',
    lastPage: 'Last Page',
    firstPage: 'First Page',
    previousPage: 'Previous Page',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.'
};

export const AG_GRID_LOCALE_FR =  {
    // Set Filter
    selectAll: '(Tout sélectionner)',
    selectAllSearchResults: '(Sélectionner tous les résultats de recherche)',
    searchOoo: 'Rechercher…',
    blanks: '(Vides)',
    noMatches: 'Aucun résultat',

    // Number Filter & Text Filter
    filterOoo: 'Filtrer…',
    equals: 'Égale',
    notEqual: 'Différent',
    empty: 'Choisissez une réponse',

    // Number Filter
    lessThan: 'Inférieur à',
    greaterThan: 'Supérieur à',
    lessThanOrEqual: 'Inférieur ou égal',
    greaterThanOrEqual: 'Supérieur ou égal',
    inRange: 'Dans l’intervalle',
    inRangeStart: 'au',
    inRangeEnd: 'du',

    // Text Filter
    contains: 'Contient',
    notContains: 'Ne contient pas',
    startsWith: 'Commence par',
    endsWith: 'Finit par',

    // Date Filter
    dateFormatOoo: 'aaaa-mm-jj',

    // Filter Conditions
    andCondition: 'ET',
    orCondition: 'OU',

    // Filter Buttons
    applyFilter: 'Appliquer',
    resetFilter: 'Réinitialiser',
    clearFilter: 'Vider',
    cancelFilter: 'Annuler',

    // Filter Titles
    textFilter: 'Filtrer par texte',
    numberFilter: 'Filtrer par nombre',
    dateFilter: 'Filtrer par date',
    setFilter: 'Établir filtre',

    // Side Bar
    columns: 'Colonnes',
    filters: 'Filtres',

    // columns tool panel
    pivotMode: 'Mode croisée dynamique',
    groups: 'Groupes de lignes',
    rowGroupColumnsEmptyMessage: 'Glisser ici pour établir les groupes de lignes',
    values: 'Valeurs',
    valueColumnsEmptyMessage: 'Glisser ici pour agréger',
    pivots: 'Étiquettes de colonnes',
    pivotColumnsEmptyMessage: 'Glisser ici pour établir les étiquettes des colonnes',

    // Header of the Default Group Column
    group: 'Groupe',

    // Other
    loadingOoo: 'En cours de chargement...',
    noRowsToShow: 'Aucune lignes à afficher',
    enabled: 'Activé',

    // Menu
    pinColumn: 'Épingler la colonne',
    pinLeft: 'Épingler à gauche',
    pinRight: 'Épingler à droite',
    noPin: 'Aucune épingle',
    valueAggregation: 'Agrégation de valeurs',
    autosizeThiscolumn: 'Ajuster automatiquement cette colonne',
    autosizeAllColumns: 'Ajuster automatiquement toutes les colonnes',
    groupBy: 'Grouper par',
    ungroupBy: 'Dégrouper par',
    resetColumns: 'Réinitialiser les colonnes',
    expandAll: 'Développer tout',
    collapseAll: 'Réduire tout',
    copy: 'Copier',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copier avec les entêtes',
    paste: 'Coller',
    ctrlV: 'Ctrl+V',
    export: 'Exporter',
    csvExport: 'Exporter CSV',
    excelExport: 'Exporter Excel (.xlsx)',
    excelXmlExport: 'Exporter Excel (.xml)',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Somme',
    min: 'Min',
    max: 'Max',
    none: 'Aucun(e)',
    count: 'Compter',
    avg: 'Moyenne',
    filteredRows: 'Filtré',
    selectedRows: 'Sélectionné',
    totalRows: 'Total de Lignes',
    totalAndFilteredRows: 'Rangées',
    more: 'Plus',
    to: 'à',
    of: 'de',
    page: 'Page',
    nextPage: 'Page suivante',
    lastPage: 'Dernière page',
    firstPage: 'Première page',
    previousPage: 'Page précédente',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Tableau croisé dynamique & mode croisé dynamique',
    pivotChart: 'Tableau croisé dynamique',
    chartRange: 'Plage du graphique',

    columnChart: 'Colonne',
    groupedColumn: 'Groupé',
    stackedColumn: 'Empilé',
    normalizedColumn: '100% empilé',

    barChart: 'Barre',
    groupedBar: 'Groupé',
    stackedBar: 'Empilé',
    normalizedBar: '100% empilé',

    pieChart: 'Graphique circulaire',
    pie: 'Graphique circulaire',
    doughnut: 'Anneau',

    line: 'Ligne',

    xyChart: '(Nuage de points) X Y',
    scatter: 'Nuage de points',
    bubble: 'Bulle',

    areaChart: 'Aire',
    area: 'Aire',
    stackedArea: 'Empilé',
    normalizedArea: '100% empilé',

    histogramChart: 'Histogramme',

    // Charts
    pivotChartTitle: 'Graphique d’un tableau croisé dynamique',
    rangeChartTitle: 'Graphique d’une plage de données',
    settings: 'Paramètres',
    data: 'Donnée',
    format: 'Format',
    categories: 'Catégories',
    defaultCategory: '(Aucun(e))',
    series: 'Série',
    xyValues: 'Valeurs X Y',
    paired: 'Mode couplé',
    axis: 'Axe',
    navigator: 'Naviguateur',
    color: 'Couleur',
    thickness: 'Épaisseur',
    xType: 'Type X',
    automatic: 'Automatique',
    category: 'Catégorie ',
    number: 'Nombre ',
    time: 'Temps',
    xRotation: 'Rotation X',
    yRotation: 'Rotation Y',
    ticks: 'Coches',
    width: 'Largeur',
    height: 'Hauteur',
    length: 'Longueur',
    padding: 'Remplissage',
    spacing: 'Espacement',
    chart: 'Graphique',
    title: 'Titre',
    titlePlaceholder: 'Titre du graphique - double-cliquez pour modifier',
    background: 'Arrière-plan',
    font: 'Police',
    top: 'Haut',
    right: 'Droite',
    bottom: 'Bas',
    left: 'Gauche',
    labels: 'Étiquettes',
    size: 'Taille',
    minSize: 'Taille minimale',
    maxSize: 'Taille maximale',
    legend: 'Légende',
    position: 'Position',
    markerSize: 'Taille du marqueur',
    markerStroke: 'Trait du marqueur',
    markerPadding: 'Remplissage du marqueur',
    itemSpacing: 'Espacement d’éléments',
    itemPaddingX: 'Remplissage de l’élément X',
    itemPaddingY: 'Remplissage de l’élément Y',
    layoutHorizontalSpacing: 'Espacement horizontal',
    layoutVerticalSpacing: 'Espacement vertical',
    strokeWidth: 'Largeur de trait',
    offset: 'Décalage',
    offsets: 'Décalages',
    tooltips: 'Infobulles',
    callout: 'Légende',
    markers: 'Traits',
    shadow: 'Ombre',
    blur: 'Flou',
    xOffset: 'Décalage X',
    yOffset: 'Décalage Y',
    lineWidth: 'Largeur de ligne',
    normal: 'Normal',
    bold: 'Gras',
    italic: 'Italique',
    boldItalic: 'Italique gras',
    predefined: 'Prédéfinis',
    fillOpacity: 'Opacité de remplissage',
    strokeOpacity: 'Opacité de ligne',
    histogramBinCount: 'Nombre de classes',
    columnGroup: 'Colonne',
    barGroup: 'Barre',
    pieGroup: 'Graphique circulaire',
    lineGroup: 'Ligne',
    scatterGroup: '(Nuage de points)  X Y ',
    areaGroup: 'Aire',
    histogramGroup: 'Histogramme',
    groupedColumnTooltip: 'Groupé',
    stackedColumnTooltip: 'Empilé',
    normalizedColumnTooltip: '100% empilé',
    groupedBarTooltip: 'Groupé',
    stackedBarTooltip: 'Empilé',
    normalizedBarTooltip: '100% Empilé',
    pieTooltip: 'Graphique circulaire',
    doughnutTooltip: 'Anneau',
    lineTooltip: 'Ligne',
    groupedAreaTooltip: 'Aire',
    stackedAreaTooltip: 'Empilé',
    normalizedAreaTooltip: '100% empilé',
    scatterTooltip: 'Nuage de points',
    bubbleTooltip: 'Bulle',
    histogramTooltip: 'Histogramme',
    noDataToChart: 'Aucune donnée disponible ne peut être mis en tableau',
    pivotChartRequiresPivotMode: 'Le tableau croisé dynamique nécessite l’activitation du mode croisé dynamique'
};
